import React from "react";
import PageShell from "@/components/PageShell";
import Preloader from "@/components/Preloader";
import Hero from "@/components/Hero";
import StudioBrief from "@/components/StudioBrief";
import Work from "@/components/Work";

export default function Home() {
    return (
        <>
            <Preloader />
            <PageShell>
                <Hero />
                <StudioBrief />
                <Work />
            </PageShell>
        </>
    );
}
